import axios from "../../../services/axios-config";

export async function getUserAccess({ userId }) {
    try {
        const response = await axios.get("/admin/users/access", {
            params: { userId },
        });

        return response?.data?.data ?? { email: null, password: null };

    } catch (error) {
        console.error('ERROR - GET USER ACCESS SERVICE:', error);
        throw error;
    }
}
